const isMobile = window.innerWidth < 1200;
const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);
const isPrivatePage = document.body.classList.contains('template-page-private-access');
const isContactPage = document.body.classList.contains('template-page-contact');

let scroll = null;
let lastScroll = 0;

if (!isMobile && !isIOS && !isPrivatePage && !isContactPage) {
  scroll = new LocomotiveScroll({
    el: document.querySelector("[data-scroll-container]"),
    smooth: true,
    multiplier: 2,
  });

  window.addEventListener("load", () => {
    scroll.update();
  });

  document.querySelectorAll("img").forEach(img => {
    img.addEventListener("load", () => scroll.update());
  });

  scroll.on("scroll", (obj) => {
    const current = obj.scroll.y;
    handleHeader(current);
    lastScroll = current; // ✅ update AFTER
  });

} else {
  window.addEventListener("scroll", () => {
    const current = window.scrollY;
    handleHeader(current);
    lastScroll = current; // ✅ update AFTER
  });
}

// shared logic
function handleHeader(current) {
  const header = document.querySelector(".section-header.shopify-section-group-header-group");
  if (!header) return;

  if (current > lastScroll && current > 50) {
    header.classList.add("shopify-section-header-hidden");
  } else if (current < lastScroll) {
    header.classList.remove("shopify-section-header-hidden");
  }

  if (current <= 0) {
    header.classList.remove("shopify-section-header-sticky");
  } else {
    header.classList.add("shopify-section-header-sticky");
  }
}